import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link } from "react-router-dom";
import {
  FaCamera,
  FaPaypal,
  FaRegCircle,
  FaRegDotCircle,
  FaStripe,
} from "react-icons/fa";
import Mapimage from "../../../assets/Map.png";
import PersonalDetails from "../Delivery/PersonalDetails";
import creditcardlogo from "../../../assets/creditcardlogo.png";

const EditAccount = () => {
  // State to manage selected payment method
  const [selectedMethod, setSelectedMethod] = useState("");
  const [iconSize, setIconSize] = useState(20); // Default size

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIconSize(21.66); // Large screens
      } else if (window.innerWidth >= 768) {
        setIconSize(15.15); // Medium screens
      } else {
        setIconSize(13.79); // Small screens
      }
    };

    handleResize(); // Set size initially
    window.addEventListener("resize", handleResize); // Listen for screen size changes

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);
  // Function to handle selection
  const handleSelect = (method) => {
    setSelectedMethod(method);
  };
  // Initial form fields data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    postCode: "",
    city: "",
    streetAddress: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submit (optional functionality)
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  return (
    <div className="lg:max-w-[80%] sm:max-w-[80%] max-w-[90%] md:max-w-[80%] mx-auto p-4 bg-white rounded-xl shadow-sm mb-5">
      <Link to="/dashboard">
        <GoArrowLeft className="text-[1.5rem] cursor-pointer" />
      </Link>

      {/* Form Section */}
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 mt-6">
          <div className="flex  items-center justify-between cursor-pointer ">
            <input
              type="text"
              placeholder="Name"
              className="lg:text-[25px] text-[14px] lg:w-[80%] w-[70%]  sm:w-[70%] md:w-[70%] lg:h-[80px] h-[50px] sm:h-[50px] md:h-[70px] font-baloo text-[#000000]  bg-[#F2EBEB] border border-gray-300 rounded-md p-2"
            />
            <div className="flex gap-4 items-center">
              <div className=" bg-[#F2EBEB] md:w-16 md:h-16 h-10 w-10 rounded-full flex items-center justify-center">
                <FaCamera className=" lg:text-[2rem] text-[1.5rem] text-gray-600 " />
              </div>
              <div className="flex  font-bold flex-col items-center sm:text-[8px] text-[8px] md:text-[.7rem] text-[#AF313D]">
                <h1>Upload Photo</h1>
                <p>(optional)</p>
              </div>
            </div>
          </div>
          {[
            { name: "email", placeholder: "Email" },
            { name: "mobileNumber", placeholder: "Phone Number" },
            { name: "postCode", placeholder: "Post Code" },
            { name: "city", placeholder: "City" },
            { name: "streetAddress", placeholder: "Street Address" },
          ].map(({ name, placeholder }) => (
            <input
              type="text"
              name={name}
              placeholder={placeholder}
              value={formData[name]}
              onChange={handleChange}
              className="w-full lg:text-[25px] text-[14px] lg:h-[80px] h-[50px] sm:h-[50px] md:h-[70px] font-baloo text-[#000000]  bg-[#F2EBEB] border border-gray-300 rounded-md p-2"
            />
          ))}
        <div className="flex flex-row items-stretch gap-4 justify-center ">
  {/* Left Side - Image */}
  <div className="w-[50%] h-auto flex items-center justify-center">
    <img src={Mapimage} alt="" className="w-full h-full object-cover" />
  </div>

  {/* Right Side - Payment Options */}
  <div className="w-[50%] flex items-center">
    <div className="container w-full shadow-md border border-[#FDFDFD]">
      <h1 className="lg:text-[49.61px] text-[15px] md:text-[31.68px] sm:text-[15px] font-baloo font-semibold text-center">
        Payment Options
      </h1>

      <form className="w-[90%] md:w-full mx-auto bg-white md:p-4 p-2 rounded-lg">
        <div className="flex flex-col gap-3">
          {/* Credit/Debit Card Option */}
          <div className="flex-1 gap-4 flex flex-col relative">
            <label
              className="relative w-full cursor-pointer"
              onClick={() => handleSelect("creditcard")}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="creditcard"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] border-gray-300 rounded-md hover:border-blue-500 transition duration-200">
                {selectedMethod === "creditcard" ? (
                  <FaRegDotCircle
                    className="text-blue-500"
                    size={iconSize}
                  />
                ) : (
                  <FaRegCircle
                    className="text-gray-500"
                    size={iconSize}
                  />
                )}
                <img
                  src={creditcardlogo}
                  alt="Logo"
                  className="h-[13.16px] sm:h-[13.16px] lg:h-[38.99px] w-[13.83px] sm:w-[13.83px] lg:w-[38.99px] mr-2"
                />
                <span className="lg:text-[21.99px] md:text-[18.18px] text-[7.55px] text-[#515978] font-baloo font-medium">
                  Credit Card / Debit Card
                </span>
              </div>
            </label>
          </div>

          {/* Stripe Option */}
          <div className="flex-1 gap-4 flex flex-col relative">
            <label
              className="relative w-full cursor-pointer"
              onClick={() => handleSelect("stripe")}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="stripe"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] border-gray-300 rounded-md hover:border-blue-500 transition duration-200">
                {selectedMethod === "stripe" ? (
                  <FaRegDotCircle
                    className="text-blue-500"
                    size={iconSize}
                  />
                ) : (
                  <FaRegCircle
                    className="text-gray-500"
                    size={iconSize}
                  />
                )}
                <FaStripe className="text-[#635BFF] sm:text-[20px] text-[20px] md:text-[30px] lg:text-6xl" />
                <span className="lg:text-[21.99px] md:text-[18.18px] text-[7.55px] text-[#515978] font-baloo font-medium">
                  Stripe
                </span>
              </div>
            </label>
          </div>

          {/* PayPal Option */}
          <div className="flex-1 gap-4 flex flex-col relative">
            <label
              className="relative w-full cursor-pointer"
              onClick={() => handleSelect("paypal")}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="paypal"
                className="hidden"
              />
              <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] border-gray-300 rounded-md hover:border-blue-500 transition duration-200">
                {selectedMethod === "paypal" ? (
                  <FaRegDotCircle
                    className="text-blue-500"
                    size={iconSize}
                  />
                ) : (
                  <FaRegCircle
                    className="text-gray-500"
                    size={iconSize}
                  />
                )}
                <FaPaypal className="text-[#27346A] sm:text-[20px] text-[20px] md:text-[30px] lg:text-4xl" />
                <span className="lg:text-[21.99px] md:text-[18.18px] text-[7.55px] text-[#515978] font-baloo font-medium">
                  PayPal
                </span>
              </div>
            </label>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

        </div>

        {/* Submit Button */}
        <div className="bg-[#AC313C] flex items-center rounded-md lg:mt-10 justify-center text-center  mx-auto md:h-[70px] h-[50px] lg:h-[80px] mt-5">
         
        </div>
      </form>
    </div>
  );
};

export default EditAccount;
